import { createContext, useContext, useState } from 'react';
import translations from '../translations/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [currentLanguage, setCurrentLanguage] = useState('en');

    const changeLanguage = (language) => {
        // Convert language code to lowercase to match our translations object keys
        const lang = language.toLowerCase();
        if (translations[lang]) {
            setCurrentLanguage(lang);
        } else {
            console.warn(`Language '${language}' is not supported. Falling back to English.`);
            setCurrentLanguage('en');
        }
    };

    // Helper function to get translated text
    const t = (key) => {
        const lang = currentLanguage.toLowerCase();
        // Try to get the translation for the current language
        if (translations[lang] && translations[lang][key]) {
            return translations[lang][key];
        }
        // Fallback to English if translation is missing
        if (translations.en && translations.en[key]) {
            return translations.en[key];
        }
        // Return the key itself if no translation is found
        console.warn(`Translation missing for key: ${key}`);
        return key;
    };

    return (
        <LanguageContext.Provider
            value={{
                currentLanguage,
                changeLanguage,
                t // Expose the translation function
            }}
        >
            {children}
        </LanguageContext.Provider>
    );
}

// Custom hook to use the language context
export function useLanguage() {
    const context = useContext(LanguageContext);
    if (context === undefined) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}
